import { invalidateCoachingSurfaces } from "./query-invalidation.js";
import { queryKeys } from "./query-keys.js";
const coachee = (scope) => (typeof scope === "string" ? scope : null);
const AREA_KEYS = {
    thread: (scope) => [queryKeys.coachingThread(scope)],
    notes: (scope) => [queryKeys.coachingNotes(scope), ...preRead(scope)],
    actions: (scope) => [queryKeys.coachingActions(scope), ...preRead(scope)],
    assessments: (scope) => {
        const id = coachee(scope);
        return id ? [queryKeys.coachAssessments(id)] : [];
    },
    sharing: (scope) => [queryKeys.coachingWeek, ...preRead(scope)],
};
function preRead(scope) {
    const id = coachee(scope);
    return id ? [queryKeys.coachPreRead(id)] : [];
}
/**
 * Refetches what one area of a relationship feeds: its own list, then the counts and cards
 * built from it (the coach's caseload and attention, or the member's own summary).
 */
export async function invalidateCoachingArea(queryClient, area, scope) {
    const id = coachee(scope);
    const summaries = id
        ? [
            { queryKey: queryKeys.coachCoachees, exact: true },
            { queryKey: queryKeys.coachUnread },
            { queryKey: queryKeys.coachCoachee(id), exact: true },
            { queryKey: queryKeys.coachAttention },
        ]
        : [
            {
                queryKey: queryKeys.coachingMe(typeof scope === "object" ? scope.kind : "coaching"),
                exact: true,
            },
            { queryKey: queryKeys.coachingProgrammes },
        ];
    await Promise.all([...AREA_KEYS[area](scope).map((queryKey) => ({ queryKey })), ...summaries].map((f) => queryClient.invalidateQueries(f)));
}
/** Options for any coaching write: run it, record it, confirm it, refresh what it changed. */
export function coachingChangeOptions(queryClient, notify, onDone) {
    return {
        mutationFn: ({ run }) => run(),
        onSuccess: (result, change) => {
            change.track?.(result);
            onDone?.();
            if (change.done)
                notify(typeof change.done === "string" ? change.done : change.done(result));
            if (change.keys) {
                return Promise.all(change.keys.map((queryKey) => queryClient.invalidateQueries({ queryKey }))).then(() => undefined);
            }
            return change.area
                ? invalidateCoachingArea(queryClient, change.area, change.scope)
                : invalidateCoachingSurfaces(queryClient);
        },
    };
}
//# sourceMappingURL=coaching-change.js.map